import { supabase } from '../config/supabase';
import toast from 'react-hot-toast';

export const useAdminModules = () => {
  const createModule = async (courseId, moduleData) => {
    try {
      const { data, error } = await supabase
        .from('modules')
        .insert([{ course_id: courseId, ...moduleData }])
        .select()
        .single();

      if (error) throw error;

      toast.success('Module created successfully');
      return { data, error: null };
    } catch (error) {
      console.error('Error creating module:', error);
      toast.error('Failed to create module');
      return { data: null, error };
    }
  };

  const updateModule = async (moduleId, updates) => {
    try {
      const { data, error } = await supabase
        .from('modules')
        .update(updates)
        .eq('id', moduleId)
        .select()
        .single();

      if (error) throw error;

      toast.success('Module updated successfully');
      return { data, error: null };
    } catch (error) {
      console.error('Error updating module:', error);
      toast.error('Failed to update module');
      return { data: null, error };
    }
  };

  const deleteModule = async (moduleId) => {
    try {
      const { error } = await supabase
        .from('modules')
        .delete()
        .eq('id', moduleId);

      if (error) throw error;

      toast.success('Module deleted successfully');
      return { error: null };
    } catch (error) {
      console.error('Error deleting module:', error);
      toast.error('Failed to delete module');
      return { error };
    }
  };

  const reorderModules = async (modules, sourceIndex, destinationIndex) => {
    try {
      // Create new order
      const reorderedModules = Array.from(modules);
      const [removed] = reorderedModules.splice(sourceIndex, 1);
      reorderedModules.splice(destinationIndex, 0, removed);

      // Update order_index for all modules
      const updates = reorderedModules.map((module, index) => ({
        id: module.id,
        order_index: index
      }));

      for (const update of updates) {
        await supabase
          .from('modules')
          .update({ order_index: update.order_index })
          .eq('id', update.id);
      }

      return { error: null };
    } catch (error) {
      console.error('Error reordering modules:', error);
      toast.error('Failed to reorder modules');
      return { error };
    }
  };

  return {
    createModule,
    updateModule,
    deleteModule,
    reorderModules
  };
};